/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Limit_2_ValueInputs */

const en_svc_n8n_limit_2_value = /** @type {(inputs: Svc_N8n_Limit_2_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed runs send an alert to a named person.`)
};

const lv_svc_n8n_limit_2_value = /** @type {(inputs: Svc_N8n_Limit_2_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neizdevušās izpildes nosūta brīdinājumu konkrētam cilvēkam.`)
};

/**
* | output |
* | --- |
* | "Failed runs send an alert to a named person." |
*
* @param {Svc_N8n_Limit_2_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_limit_2_value = /** @type {((inputs?: Svc_N8n_Limit_2_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Limit_2_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_limit_2_value(inputs)
	return en_svc_n8n_limit_2_value(inputs)
});